
define('jst!tasks/tour/_step7',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<h1><%= t("Repeating tasks #tasksfeaturetour") %></h1>\n<p><%= t("Let Podio help you stay on track with repeating tasks.") %></p>\n<p><%= t("As soon as you assign a due date, you can choose to have a task repeat itself. Pick every weekday, the 18th of each month, every 12 months. Almost endless flexibility. #tasksfeaturetour") %></p>\n');
 });

